import React from "react";

interface TopbarProps {
    toggleSidebar: () => void;
}

const Topbar: React.FC<TopbarProps> = ({ toggleSidebar }) => {
    return (
        <div className="w-full bg-white shadow-md border-b p-4 flex justify-between items-center">
            <div className="flex items-center space-x-4">
                {/* Toggle button for sidebar on mobile */}
                <button
                    onClick={toggleSidebar}
                    className="block md:hidden text-blue-600 focus:outline-none"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 6h16M4 12h16M4 18h16"
                        />
                    </svg>
                </button>
                <h2 className="text-xl font-semibold">Dashboard</h2>
            </div>
            <div className="flex items-center space-x-4">
                <button className="bg-blue-600 text-white px-4 py-2 rounded-md">Logout</button>
            </div>
        </div>
    );
};

export default Topbar;
